export enum CertificateStatus {
  DERĪGA = 'derīga',
  NEDERĪGa = 'nederīga',
}

export interface CertificateVerificationResponse {
  numurs: string
  statuss: CertificateStatus
}
